import controller from './messageOutbound.controller';
import template from './messageOutbound.html';

const MessageOutboundDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default MessageOutboundDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/messageOutbound/messageOutbound.component.js
 **/